module.exports = __webpack_public_path__ + "img/bg_business_name.619baafe.png";